import {ACCOUNT_TYPE_TO_DV_MAPPING} from '@/constants/engine';
import {DomainValueReference} from '@/model/types';

export const mapAccountTypeToDomainValue = (accountType?: string): DomainValueReference | null => {
  if (!accountType || !(accountType in ACCOUNT_TYPE_TO_DV_MAPPING)) return null;

  return {$ref: ACCOUNT_TYPE_TO_DV_MAPPING[accountType as keyof typeof ACCOUNT_TYPE_TO_DV_MAPPING]};
};
